import type { Me } from "@unbox/api";

export function workspaceForMerchant(
  workspaces: Me["workspaces"],
  merchantId: string,
  lastWorkspaceId: string | null | undefined,
): string | null {
  const containing = workspaces.filter((w) => w.merchants.some((m) => m.id === merchantId));
  const ownerWorkspaceId = containing[0]?.merchants.find((m) => m.id === merchantId)?.ownerWorkspaceId;
  return (
    containing.find((w) => w.id === lastWorkspaceId)?.id ??
    containing.find((w) => w.id === ownerWorkspaceId)?.id ??
    containing[0]?.id ??
    null
  );
}
